<button mat-icon-button [matMenuTriggerFor]="navMenu" class="fixed top-0 z-9999">
    <mat-icon class="taupe-grey">menu</mat-icon>
</button>
<mat-menu #navMenu="matMenu">
    <button mat-icon-button>
        <mat-icon class="taupe-grey">close</mat-icon>
    </button>
    <a mat-menu-item *ngFor="let option of navOptions" [routerLink]="option.route" routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: true}" mat-menu-item class="taupe-grey no-underline">{{ option.display }}</a>
</mat-menu>